import React, { useEffect, useState } from 'react';
import { Table, Button, Form, FormControl, Modal, Spinner, Container, Row, Col } from 'react-bootstrap';
import FormSurvival from './FormSurvival';
import { ReactIcons } from '../../../icons';
import { GET_SUVIVALS } from '../../../apollo/unit/Query';
import { covertTimeZone } from '../../../helper';
import { useLazyQuery, useMutation } from '@apollo/client';
import { DELETED_SURVIVAL } from '../../../apollo/unit/Mutation';
import AnimationLoading from '../../../components/Animationloading';

const SurvivalNumber = () => {
    const [onShowModal, setOnShowModal] = useState({
        isOpen: false,
        data: null,
        editMode: false
    });
    const [survivalDatas, setSurvivalDatas] = useState([]);
    // const [survivalTotal, setSurvivalTotal] = useState(0);
    const [idDeleted, setIdDeleted] = useState(null);
    const [survivalNumber, setSurvivalNumber] = useState('');
    const [queryStatus, setQueryStatus] = useState(true);

    // apollo client hooks
    const [getSurvivalData, { loading: loadingSurvival, data: survivalDatasLoad, error }] = useLazyQuery(GET_SUVIVALS, {
        fetchPolicy: "cache-and-network"
    });
    const [deletedSurvival, { loading: loadingDeleteSurvival }] = useMutation(DELETED_SURVIVAL);

    // useEffect Hooks
    useEffect(() => {
        // Get shop data from localStorage
        const userData = localStorage.getItem("SHOP_DATA");
        if (userData) {
            const locals = JSON.parse(userData);
            if (locals) {
                fetchSurvivalDatas(locals.id);
            }
        }
    }, [queryStatus, survivalNumber])

    useEffect(() => {
        if (survivalDatasLoad) {
            setSurvivalDatas(survivalDatasLoad?.survivals?.data || []);
            // setSurvivalTotal(survivalDatasLoad?.survivals.total || 0);
        }
    }, [survivalDatasLoad]);

    // Handle errors during fetching
    useEffect(() => {
        if (error) {
            console.log("Error loading survival data:", error.message);
        }
    }, [error]);

    // Fetch survival data based on shop ID
    const fetchSurvivalDatas = async (shopId) => {
        if (loadingSurvival) return; // Prevent re-triggering if already loading
        let where = {
            shop: shopId,
            status: queryStatus,
            isDeleted: false
        }
        if (survivalNumber !== ''){
            where = {...where, survivalNumber}
        }
        try {
            await getSurvivalData({
                variables: {
                    where
                }
            });
        } catch (err) {
            console.log("Load survival error: ", err);
        }
    }

    const handleCloseModal = () => {
        setOnShowModal({
            isOpen: false,
            data: null,
            editMode: false
        })
        const userData = localStorage.getItem("SHOP_DATA");
        if (userData) {
            const locals = JSON.parse(userData);
            if (locals) {
                fetchSurvivalDatas(locals.id);
            }
        }
    }

    // delete survival
    const handleDeleteSurvival = async (id) => {
        if (loadingDeleteSurvival) return;
        setIdDeleted(id)
        try {
            const res = await deletedSurvival({
                variables: {
                    where: {
                        id: id
                    }
                }
            });
            if (res) {
                handleCloseModal()
            }
        } catch (error) {
            console.log({ error })
        }
    }



    return (
        <div className="container p-4 bg-white">
            <Container className='mb-2'>
                <Row>
                    <Col xs={6}>
                        <FormControl
                            type="text"
                            value={survivalNumber}
                            onChange={(e) => {
                                console.log("e?.target?.value:", e?.target?.value);
                                setSurvivalNumber(e?.target?.value)
                            }}
                            placeholder="Search..."
                            className="w-80"
                        />
                    </Col>
                    <Col md="auto">
                        <Form.Check.Input
                            type="checkbox"
                            name="status"
                            onChange={(e) => {
                                console.log("e", e, e?.target?.checked);
                                setQueryStatus(e?.target?.checked)}}
                            value={queryStatus}
                            checked={queryStatus}
                            className='mr-5'
                        />
                        <Form.Check.Label>ສະຖານະ( 
                            <span style={{ color: queryStatus === false ? "red" : "green" }}>
                                {queryStatus === false ? "ປີດ" : "ເປີດ"}
                            </span>)
                        </Form.Check.Label>
                    </Col>
                    <Col xs lg="2">
                        <Button variant="primary" onClick={() => setOnShowModal({ isOpen: true, data: null, editMode: false })}>
                            <ReactIcons.MdAdd /> ເພິ່ມ
                        </Button>
                    </Col>
                </Row>
            </Container>

            {(loadingSurvival && !survivalDatasLoad) ? <AnimationLoading /> : <Table striped bordered hover responsive>
                <thead>
                    <tr>
                        <th>ລຳດັບ</th>
                        <th>ໝາຍເລກລອດ</th>
                        <th>ວັນທີ,ເດືອນ,ປີ</th>
                        <th>ສະຖານະ</th>
                        <th style={{ textAlign: 'right' }}>ຈັດການ</th>
                    </tr>
                </thead>
                <tbody>
                    {survivalDatas.map((item, index) => (
                        <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item?.survivalNumber ?? "-"}</td>
                            <td>{covertTimeZone(item?.createdAt)}</td>
                            <td> 
                                <span className = {item?.status === false ? "badge bg-danger" : "badge bg-success"}>
                                    {item?.status === false ? "ປີດ" : "ເປີດ"}
                                </span>
                            </td>
                            <td style={{ textAlign: 'right' }}>
                                <Button variant="outline-info" className="mr-2" onClick={() => setOnShowModal({ isOpen: true, data: item, editMode: true })}>
                                    <ReactIcons.MdEdit />
                                </Button> &nbsp;
                                <Button disabled={loadingDeleteSurvival} variant="outline-danger" onClick={() => handleDeleteSurvival(item?.id)}>
                                    {(loadingDeleteSurvival && idDeleted === item?.id) ? <Spinner size="sm" /> : <ReactIcons.MdDeleteOutline />}
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>}

            <Modal show={onShowModal.isOpen} onHide={handleCloseModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{onShowModal.editMode ? "ແກ້ໄຂເລກລອດ" : "ເພິ່ມເລກລອດ"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FormSurvival data={onShowModal.data} editMode={onShowModal.editMode} onClose={handleCloseModal} />
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default SurvivalNumber;
